import React from 'react';

export default function TaxRatesTooltip(props) {
	// console.log('TaxRatesTooltip', props);
	return (
		<div className="px-3 py-1 text-sm">
			<ul>
				<li className='my-2'>4.715% - Maui GE (Honolulu City & County)</li>
				<li className='my-2'>10.0% - Transient Accommodations Tax (Maui)</li>
			</ul>
		</div>
	);
}
